import { useTheme } from '@app/styled';
import { Flex, SuccessIcon } from '@lokalise/louis';

import { IconContainer, SyncButtonContainer, TextContainer } from '../styles';

const SyncedStateButton = ({ onClick }: { onClick: () => void }) => {
    const theme = useTheme();

    return (
        <SyncButtonContainer onClick={onClick} aria-label="View AI Summary">
            <Flex align="center" wrap="nowrap">
                <IconContainer align="center" justify="center">
                    <SuccessIcon size="16px" color={theme.color.text.ai} />
                </IconContainer>
                <TextContainer>View AI Summary</TextContainer>
            </Flex>
        </SyncButtonContainer>
    );
};

export default SyncedStateButton;
